import { DomHelper } from '../helpers/DomHelper';
export var PdfJsDistVersion;
(function (PdfJsDistVersion) {
    PdfJsDistVersion["Generic"] = "generic";
    PdfJsDistVersion["IE11Ledge"] = "ie11-ledge";
})(PdfJsDistVersion || (PdfJsDistVersion = {}));
// npx browserslist-useragent-regexp 'Chrome > 90, Firefox >= 91, Safari >= 15.4' --allowHigherVersions
// Firefox version is the ESR at the moment pdf.js library got released. So in this case 91.
// Safari needs to be 15.4 for StructuredClone support (https://caniuse.com/?search=structuredclone)
export const PdfJsDistVersionBrowserListUserAgentRegex = {
    [PdfJsDistVersion.Generic]: {
        query: 'Chrome > 90, Firefox >= 91, Safari >= 15.4',
        regex: /Firefox\/(9[1-9]|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(9[1-9]|\d{3,})\.\d+(\.\d+|)|Maci.+ Version\/(15\.([4-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( Mobile\/\w+|) Safari\//
    },
    [PdfJsDistVersion.IE11Ledge]: {
        query: '',
        regex: /(.*?)/
    }
};
export class PdfJsDistService {
    constructor(config) {
        this.config = config;
    }
    loadResources() {
        const versionConfig = this.calculateVersionBasedOnUserAgent();
        return new Promise((resolve, reject) => {
            DomHelper.loadScript(versionConfig.src)
                .then(() => DomHelper.loadLink(versionConfig.textLayerBuilderCssUrl))
                .then(() => DomHelper.loadLink(versionConfig.annotationLayerBuilderCssUrl))
                .then(() => {
                const pdfjsLib = window.pdfjsLib;
                pdfjsLib.GlobalWorkerOptions.workerSrc = versionConfig.workerSrc;
                resolve({ pdfjsLib, versionConfig });
            })
                .catch(error => reject(error));
        });
    }
    calculateVersionBasedOnUserAgent() {
        const userAgent = navigator.userAgent || '';
        return this.config.versions.find(pdfJsDistVersion => userAgent.match(PdfJsDistVersionBrowserListUserAgentRegex[pdfJsDistVersion.version].regex));
    }
}
//# sourceMappingURL=pdfjs-dist-service.js.map